import { generateKeyFromTab } from '@sravni/ugc/lib/specialOffers/helpers';
import type { Tab, VITRINS_OFFERS_TYPE } from '@sravni/ugc/lib/specialOffers/types';

import type { GlobalState } from '../index';
import type { IState } from '../reducers/offers';

export const getOffersSelector = (state: GlobalState): IState['offers'] => state.offers.offers;
export const getOffersByTypeSelector = (type: Tab<VITRINS_OFFERS_TYPE>) => (state: GlobalState): any[] =>
  state.offers.offers?.[generateKeyFromTab(type)]?.list;
export const getAnalyticsParamsSelector = (state: GlobalState): IState['analyticsParams'] =>
  state.offers.analyticsParams;
export const getIsAnalyticsParamsLoaded = (state: GlobalState): IState['isAnalyticsParamsLoaded'] =>
  state.offers.isAnalyticsParamsLoaded;
export const getActiveTabType = (state: GlobalState): IState['activeTabType'] => state.offers.activeTabType;
export const getPixels = (state: GlobalState): IState['pixels'] => state.offers.pixels;
export const getAvailableTabs = (state: GlobalState): IState['availableTabs'] => state.offers.availableTabs;
export const getOffersHaveBeenLoadedByType = (type: Tab<VITRINS_OFFERS_TYPE>) => (state: GlobalState): boolean =>
  !!state.offers.offers?.[generateKeyFromTab(type)]?.list?.length;
export const getAreOffersLoadingByType = (type: Tab<VITRINS_OFFERS_TYPE>) => (state: GlobalState): boolean =>
  state.offers.offers?.[generateKeyFromTab(type)]?.isLoading;
export const getRequestForOrganizationDone = (state: GlobalState): boolean => state.offers.isRequestForOrganizationDone;
